import React from "react";
import { useTranslation } from "react-i18next";
import * as SC from "./BudgetCheckNavigation.styled";

const BudgetCheckNavigation = ({ onNextStep, onBackStep }) => {
  const { t } = useTranslation();

  return (
    <SC.NavigationWrapper>
      <SC.ActionButtonsWrapper>
        <SC.BackButton onClick={onBackStep}>{t("Back")}</SC.BackButton>
      </SC.ActionButtonsWrapper>
      <SC.ActionButtonsWrapper>
        <div data-tip data-for="next-button">
          <SC.ContinueButton onClick={onNextStep} id="next-button-booking">
            {t("Create campaign")}
          </SC.ContinueButton>
        </div>
      </SC.ActionButtonsWrapper>
    </SC.NavigationWrapper>
  );
};

export default BudgetCheckNavigation;
